import { cn, Link } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import styles from './Rules.module.css';

import type { FC, HTMLAttributes } from 'react';

interface RulesProps extends HTMLAttributes<HTMLDivElement> {
  rules: RulesData;
}

export type RulesData = {
  title: string;
  items: {
    bonusImage: string;
    text: string;
  }[];
  link: {
    text: string;
    href: string;
  };
};

const Rules: FC<RulesProps> = (props) => {
  const { className, rules, ...restProps } = props;
  const itemsCount = rules.items.length;

  const handleClickRules = () => {
    ModalWindows.open('StaticInfo', { slug: 'divan-club-rules', hash: rules.link.href });
  };

  return (
    <div className={cn(styles.wrapper, className)} {...restProps}>
      <div className={styles.title}>{rules.title}</div>
      <div
        className={cn(styles.rules, {
          [styles.oddCount]: itemsCount % 2 !== 0,
          [styles.evenCount]: itemsCount % 2 === 0,
        })}
      >
        {rules.items.map((rule) => (
          <div className={styles.rule} key={rule.text}>
            <img className={styles.image} src={rule.bonusImage} />
            <div className={styles.text} dangerouslySetInnerHTML={{ __html: rule.text }} />
          </div>
        ))}
      </div>
      <Link className={styles.link} onClick={handleClickRules} view='primary' underlined>
        {rules.link.text}
      </Link>
    </div>
  );
};

export default Rules;
